import constants from '@/constants';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['getFeatureSwitch']),

    isCustomFieldsFeatureActive() {
      return !this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.NO_CUSTOM_FIELDS);
    },

    isSelectableTimeTypeFeatureActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.SELECTABLE_TIME_TYPES);
    },

    isTimePairAddFeatureActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.ADD_TIME_PAIRS);
    },

    isTimePairEditFeatureActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.EDIT_TIME_PAIRS);
    },

    isTimePairApprovalFeatureActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.APPROVE_TIME_PAIRS);
    },

    isSegmentTimePairFeatureActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.SEGMENT_TIME_PAIRS);
    },

    isFilterApprovalsByStatusActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.FILTER_APPROVALS_BY_STATUS);
    },

    isDeleteTimePairActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.DELETE_TIME_PAIRS);
    },

    isCloneTimeActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.CLONE_TIME_PAIRS);
    },

    isFreeTextCorrectionReasonsActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.FREE_TEXT_CORRECTION_REASONS);
    },

    isMissedClockOutNotificationActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.MISSED_CLOCK_OUT_NOTIFICATIONS);
    },

    isMissedClockInNotificationActive() {
      return this.getFeatureSwitch(constants.FEATURE_SWITCHES_TITLES.MISSED_CLOCK_IN_NOTIFICATIONS);
    },
  },
};
